import React from 'react';
import { CommentEditor } from './commentEditor';
import { useCommentImprove } from './useCommentImprove';

/**
 * <CommentEditor /> pre-wired with an AI-backed `onImprove` (aiTransform store,
 * streamed). Drop-in replacement wherever the "Improve" button should be live —
 * used by <Comments enableAiImprove /> (e.g. the submitted-claims comments
 * popper). Keeping the AI wiring in this thin wrapper means the socket listener
 * only mounts where improve is enabled, not on every comment editor.
 */
export const CommentEditorAi = (props) => {
    const onImprove = useCommentImprove();
    return <CommentEditor {...props} onImprove={onImprove} />;
};
